<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12" md="4">
        <material-card title="Informações">
          <div class="author">
            <img :src="profile" class="avatar" />
            <h4 class="font-weight-black primary--text title">{{$user.nome}}</h4>
            <h4 class="font-weight-light primary--text body-2">{{$user.email}}</h4>
          </div>
          <template v-slot:header>
            <!-- <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="profile"></v-img>
              </v-list-item-avatar>
            </v-list-item>
            </v-list>-->
          </template>
        </material-card>
      </v-col>
      <v-col cols="12" md="8">
        <material-card title="Editar Perfil" text="Complete as informações">
          <v-form ref="formProfile">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    disabled
                    outlined
                    :rules="requiredRule"
                    label="Nome"
                    v-model="data.nome"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    disabled
                    :rules="requiredRule"
                    label="Email"
                    v-model="data.email"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <password-field
                    :rules="requiredRule"
                    outlined
                    type="password"
                    label="Senha Atual"
                    v-model="data.currentPassword"
                  ></password-field>
                </v-col>
                <v-col cols="12" md="4">
                  <password-field
                    :rules="requiredRule"
                    outlined
                    type="password"
                    label="Nova Senha"
                    v-model="data.newPassword"
                  ></password-field>
                </v-col>
                <v-col cols="12" md="4">
                  <password-field
                    :rules="requiredRule"
                    outlined
                    type="password"
                    label="Confirmar Nova Senha"
                    v-model="data.confirmNewPassword"
                  ></password-field>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn @click="updateProfile()" color="success">Atualizar</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import CurrencyField from "../../components/shared/CurrencyField";
import rules from "../../utils/rules";
import PasswordField from "../../components/shared/PasswordField";
//import { Encrypt } from "@/utils/encrypt";
import { mapActions } from "vuex";

export default {
  mixins: [rules],
  components: {
    PasswordField
  },
  mounted() {
    this.updateDataToForm();
  },
  data() {
    return {
      profile: require("@/assets/profile.png"),
      data: {
        email: "",
        nome: "",
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null
      }
    };
  },
  methods: {
    ...mapActions("auth", ["alterarSenha"]),
    updateDataToForm() {
      this.data.email = this.$user.email;
      this.data.nome = this.$user.nome;
    },
    updateProfile() {
      if (this.$refs.formProfile.validate()) {
        this.alterarSenha({
          senhaAntiga: this.data.currentPassword,
          senha: this.data.newPassword,
          confirmaSenha: this.data.confirmNewPassword
        }).then(() => {
          this.openAlertSuccess("Senha alterada com sucesso");
          this.$refs.formProfile.reset();
          setTimeout(() => {
            this.updateDataToForm();
          }, 100);
        });
      }
    }
  }
};
</script>

<style>
.author {
  text-align: center;
  text-transform: none;
  /* margin-top: -40px; */
}

.author .avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: relative;
  margin-bottom: 15px;
}
</style>